module.exports = "<div class=\"alert alert-info nav-item\" (click)=\"getFile(file)\">\r\n  {{file.name}} ({{file.size | toMBytes}})\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/file/file.component.html
// module id = ../../../../../src/app/shared-module/file/file.component.html
// module chunks = 5